<template>
  <div class="home">

    <ScrollyTellingFeed/>

  </div>
</template>

<script>
// @ is an alias to /src
import ScrollyTellingFeed from '@/components/ScrollyTellingFeed.vue'

export default {
  name: 'home',
  components: {
    ScrollyTellingFeed
  }
}
</script>

<style scoped>

  .home{
    width: 400px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: white;
  }

</style>
